import { applyMiddleware, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import { createRootReducer, rootEpic } from './root';
import epicMiddlewareFn from './epic-middleware';

const epicMiddleware = epicMiddlewareFn(createEpicMiddleware);

// @ts-ignore
const logger = (store) => (next) => (action) => {
  console.log('dispatching', action);
  let result = next(action);
  console.log('next state', store.getState());
  return result;
};

const middleware = [epicMiddleware, logger];

export const configureStore = (preloadedState?: {}) => {
  const store = createStore(
    createRootReducer(),
    preloadedState,
    applyMiddleware(...middleware),
  );
  epicMiddleware.run(rootEpic);
  return store;
};
